import { styled, withStyle } from '@olxeu-jobs/ui';
import { Platform } from '~types';

const Base = styled('div', {
  ':empty': {
    display: 'none',
  },
});

export const FullWidth = withStyle<typeof Base, { $mobile?: boolean; $desktop?: boolean }>(
  Base,
  ({ $theme, $mobile, $desktop }) => {
    if (
      (!$mobile && !$desktop) ||
      ($mobile && $theme.platform === Platform.MOBILE) ||
      ($desktop && $theme.platform === Platform.DESKTOP)
    ) {
      return {
        position: 'relative',
        width: '100vw',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
      };
    }

    return {};
  },
);
